import React, { useRef } from 'react';

type Props = {
    handleChange: (e: any) => void;
    removeImage?: () => void;
    image: any;
    imageSelected: any;
    name: string;
    id?: string; // Prop opcional para pasar un ID único
};

const InputImageRounded = ({
    handleChange,
    removeImage,
    image,
    imageSelected,
    name,
    id
}: Props) => {
    const inputId = id || name; // Usa 'id' si se pasa, o usa 'name' como respaldo

    return (
        <>
            <div className="col-md-12 text-center d-flex">
                <div className="mx-auto mb-3">
                    <label htmlFor={inputId}>
                        <img
                            src={
                                typeof image === 'string' && image !== ''
                                    ? image
                                    : window.URL.createObjectURL(image as unknown as Blob)
                            }
                            className="rounded-circle pointer bg-white"
                            style={{
                                width: '150px',
                                height: '150px',
                                objectFit: 'cover',
                                border: '2px solid #ccc'
                            }}
                        />
                    </label>
                </div>
                <input
                    type="file"
                    className="custom-file-input"
                    style={{ height: '0px', width: '0px' }}
                    id={inputId} // Cambiado para usar el id único
                    name={name}
                    accept="image/*"
                    onChange={handleChange}
                />
            </div>
            {imageSelected && (
                <div className="text-center mb-2">
                    <button
                        type="button"
                        onClick={removeImage}
                        className="btn btn-sm btn-danger"
                    >
                        Remover imagen
                    </button>
                </div>
            )}
        </>
    );
};

export default InputImageRounded;
